import { render, staticRenderFns } from "./TagesSalden.vue?vue&type=template&id=b79ebf6c&scoped=true"
import script from "./TagesSalden.vue?vue&type=script&lang=ts"
export * from "./TagesSalden.vue?vue&type=script&lang=ts"
import style0 from "./TagesSalden.vue?vue&type=style&index=0&id=b79ebf6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b79ebf6c",
  null
  
)

export default component.exports